import { render, staticRenderFns } from "./NPC.vue?vue&type=template&id=0a628ea1&"
import script from "./NPC.vue?vue&type=script&lang=js&"
export * from "./NPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a628ea1')) {
      api.createRecord('0a628ea1', component.options)
    } else {
      api.reload('0a628ea1', component.options)
    }
    module.hot.accept("./NPC.vue?vue&type=template&id=0a628ea1&", function () {
      api.rerender('0a628ea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/NPC.vue"
export default component.exports